import api from '@/services/api';
import type { CourseBatch, CourseBatchInput } from '@/types/course_batch_schema';

const BASE_URL = '/courses/batches';

export const courseBatchApi = {
  /**
   * Get all course batches
   */
  getAllBatches: async (params?: {
    page?: number;
    per_page?: number;
    search?: string;
    course_id?: string;
    status?: string;
    is_registration_open?: boolean;
  }) => {
    return api.get<{ data: CourseBatch[]; meta?: any }>(BASE_URL, { params });
  },

  /**
   * Get batches for a specific course
   */
  getBatchesByCourse: async (courseId: string) => {
    return api.get<{ data: CourseBatch[] }>(`/courses/short-courses/${courseId}/batches`);
  },

  /**
   * Get a single batch by ID
   */
  getBatchById: async (id: string) => {
    return api.get<{ data: CourseBatch }>(`${BASE_URL}/${id}`);
  },

  /**
   * Create a new batch
   */
  createBatch: async (input: CourseBatchInput) => {
    return api.post<{ data: CourseBatch }>(BASE_URL, input);
  },

  /**
   * Update an existing batch
   */
  updateBatch: async (id: string, input: Partial<CourseBatchInput>) => {
    return api.put<{ data: CourseBatch }>(`${BASE_URL}/${id}`, input);
  },

  /**
   * Delete a batch
   */
  deleteBatch: async (id: string) => {
    return api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Open registration for a batch
   */
  openRegistration: async (id: string) => {
    return api.post<{ data: CourseBatch }>(`${BASE_URL}/${id}/open-registration`);
  },

  /**
   * Close registration for a batch
   */
  closeRegistration: async (id: string) => {
    return api.post<{ data: CourseBatch }>(`${BASE_URL}/${id}/close-registration`);
  },

  /**
   * Start a batch (mark as in_progress)
   */
  startBatch: async (id: string) => {
    return api.post<{ data: CourseBatch }>(`${BASE_URL}/${id}/start`);
  },

  /**
   * Complete a batch
   */
  completeBatch: async (id: string) => {
    return api.post<{ data: CourseBatch }>(`${BASE_URL}/${id}/complete`);
  },
};

export default courseBatchApi;
